import React from 'react';

import { isInvitePending, STATUS_DEACTIVATED } from './organisationUserFormat';

import TextButton from 'CommonComponents/TextButton';

/**
 * Row actions. Clicks stop here so they do not also open the row's panel.
 */
export default function OrganisationUserRowActions({ row, canManage, isSelf, onEdit, onResend, onDeactivate, onReactivate }) {
    const act = (handler) => (event) => {
        event.stopPropagation();
        handler(row);
    };

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-1">
            <TextButton variant="primary" className="!tw-normal-case" onClick={act(onEdit)}>
                {canManage ? $t('Edit') : $t('View')}
            </TextButton>
            {canManage && isInvitePending(row.status) && (
                <TextButton variant="primary" className="!tw-normal-case" onClick={act(onResend)}>
                    {$t('Resend invite')}
                </TextButton>
            )}
            {canManage &&
                !isSelf &&
                (row.status === STATUS_DEACTIVATED ? (
                    <TextButton variant="primary" className="!tw-normal-case" onClick={act(onReactivate)}>
                        {$t('Reactivate')}
                    </TextButton>
                ) : (
                    <TextButton variant="danger" className="!tw-normal-case" onClick={act(onDeactivate)}>
                        {$t('Deactivate')}
                    </TextButton>
                ))}
        </div>
    );
}
